// @flow
const PREFIX = 'spr+';

function restoreUnicode(c) {
  return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
}

export function decode(str: string = '') {
  if (str.indexOf(PREFIX) !== 0) {
    return str;
  }
  const unprefixed = str.replace(PREFIX, '');
  return decodeURIComponent(
    Array.prototype.map.call(atob(unprefixed), restoreUnicode).join('')
  );
}

const unicode = /%([0-9A-F]{2})/g;

function replaceUnicode(match, p1) {
  return String.fromCharCode('0x' + p1);
}

export function encode(str: string = '') {
  return PREFIX + btoa(encodeURIComponent(str).replace(unicode, replaceUnicode));
}



/** WEBPACK FOOTER **
 ** ./src/lib/Base64.js
 **/